module.exports = __webpack_public_path__ + "assets/img/hkhc_case.e6fe0016.png";